import { observable, action } from 'mobx';
import { EAdminPages } from '../../../common/interfaces/admin';

export class Admin {
    @observable public page: EAdminPages = null;

    @action
    public changePage = (page: EAdminPages) => {
        this.page = page;
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/Admin.ts